import {AuctionTypeFilter} from '../../../types/AuctionTypeFilter';

/** Validate persisted JSON without mapping removed values to another auction type. */
export function readAuctionTypeFilter(filters: object) {
  const stored = 'auctionType' in filters ? filters.auctionType : undefined;
  if (stored === undefined || stored === null) {
    return {auctionType: undefined, hasUnsupportedValues: false};
  }
  if (!Array.isArray(stored)) {
    return {auctionType: undefined, hasUnsupportedValues: true};
  }

  const auctionType: AuctionTypeFilter[] = [];
  let hasUnsupportedValues = false;
  for (const value of stored) {
    const supported = Object.values(AuctionTypeFilter).find((type) => type === value);
    if (supported) {
      auctionType.push(supported);
    } else {
      hasUnsupportedValues = true;
    }
  }
  return {
    auctionType: auctionType.length > 0 ? auctionType : undefined,
    hasUnsupportedValues,
  };
}
